// extracted by mini-css-extract-plugin
module.exports = {"container":"tSBia","status":"_9qAv6","errorText":"imTyX","errorFigurePath":"dDtpJ","errorTextPath":"QmhEh"};